import { useEffect} from "react";
import {DateTimeDisplay} from "../DateTimeDisplay";

// Escolhe uma voz pt-BR realmente instalada no navegador/TV, em vez de
// assumir que existe uma voz chamada "Serena" (que nunca era aplicada de fato).
const pickPortugueseVoice = () => {
  if (typeof window === "undefined" || !window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices();
  return (
    voices.find((v) => v.lang === "pt-BR") ||
    voices.find((v) => v.lang?.startsWith("pt")) ||
    null
  );
};

// Fala um texto, aguardando a lista de vozes carregar quando necessário
// (em alguns navegadores getVoices() vem vazio na primeira chamada) e
// registrando erro no console em vez de falhar silenciosamente.
const speak = (text) => {
  if (!text || typeof window === "undefined" || !window.speechSynthesis) return;

  const utter = () => {
    const msg = new SpeechSynthesisUtterance(text);
    msg.volume = 1; //define o volume do áudio (de 0 a 1)
    msg.rate = 0.9; // define a velocidade do áudio (0.1 a 1)
    msg.pitch = 1; // define o tom em que o áudio é falado (de 0 a 2)
    msg.lang = "pt-BR";

    const voice = pickPortugueseVoice();
    if (voice) msg.voice = voice;

    msg.onerror = (event) => {
      console.error("Falha ao reproduzir áudio da chamada:", event.error, text);
    };

    window.speechSynthesis.speak(msg);
  };

  if (window.speechSynthesis.getVoices().length === 0) {
    window.speechSynthesis.addEventListener("voiceschanged", utter, { once: true });
  } else {
    utter();
  }
};

export const CardBody = ({
  name,
  practitioner,
  room,
  floor,
  link,
  lastName,
  quarto,
  speach,
  color,
  created,
}) => {
  useEffect(() => {
    speak(speach);
  }, [speach, created]);

  useEffect(() => {
    speak(quarto);
  }, [created, quarto]);

 
 

  return (
    <>
      <div className="card d-flex flex-row mb-3">
        <div className="d-flex flex-grow-1 min-width-zero">
          <div className="card-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center" style={{background:color}}>
            <a
              className="list-item-heading mb-0 truncate w-40 w-xs-100 mt-0"
              href={link}
            >
              <i className=" heading-icon" />
              <span
                className="align-middle d-inline"
                style={{ fontSize: "30px" }}
              >
                {name}
              </span>
            </a>

            <a
              className="list-item-heading mb-0 truncate w-40 w-xs-100 mt-0"
              href={link}
            >
              <i className="heading-icon" />
              <span
                className="align-middle d-inline"
                style={{ fontSize: "30px" }}
              >
                {" "}
                {practitioner}
              </span>
            </a>
            <a
              className="list-item-heading mb-0 truncate w-20 w-xs-100 mt-0"
              href={link}
            >
              <i className="heading-icon" />
              <span
                className="align-middle d-inline"
                style={{ fontSize: "30px" }}
              >
                Sala: {room}
              </span>
            </a>
            <a
              className="list-item-heading mb-0 truncate w-20 w-xs-100 mt-0"
              href={link}
            >
              <i className="heading-icon" />
              <span
                className="align-middle d-inline"
                style={{ fontSize: "30px" }}
              >
                Andar: {floor}º
              </span>
            </a>
            <a
              className="list-item-heading mb-0 truncate w-20 w-xs-100 mt-0"
              href={link}
            >
              <i className="heading-icon" />
              <span
                className="align-middle d-inline"
                style={{ fontSize: "25px" }}
              >
                Hora: <DateTimeDisplay date={created} format={"HH:mm:ss"} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
